module.exports = __webpack_public_path__ + "static/media/yizugou.010713f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/easyrentgo/index/yizugou.jpg
// module id = 1204
// module chunks = 0